import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class ClientInfoPersonal extends BaseRoute {
  @service("repositories/user-repository") userRepository;

  element = (<Template />);
  revalidateOnQueryAnyChange = false;
  revalidateOnParams = ["id"];
  revalidateOnQueryKeys = ["rvClientDetail", "client"];
  allowManualRevalidate = false;

  async loader({ request }) {
    // Get client from URL query params
    const url = new URL(request.url);
    const client = url.searchParams.get("client") || undefined;

    // Data to return
    let userData = {};

    if (client) {
      try {
        userData = await this.userRepository.findRecord(client, {
          noCache: true,
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }

    return { userData };
  }
}
